import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { AlertsAppDataProviderFactory } from '../factory/AlertsAppDataProviderFactory';
import { AlertsAppBaseDataProvider } from '../dataProvider/AlertsAppBaseDataProvider';

export class AlertsAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: AlertsAppDataProviderFactory;
  public dataProvider: AlertsAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new AlertsAppDataProviderFactory(),
    });
  }
}
